// Persistent storage: asked for once, the first time the field's runtime
// starts for an operator's session (D-83), and the answer kept in the
// session store until a sign out clears it. Without the grant the browser
// may evict the stores under pressure; with it, a working day survives.
import type { FieldcoreDb } from '../db/database';

export async function requestPersistentStorage(database: FieldcoreDb): Promise<void> {
  const existing = await database.session.get('storage');
  if (existing !== undefined) return;
  const manager = typeof navigator === 'undefined' ? undefined : navigator.storage;
  if (manager === undefined || typeof manager.persist !== 'function') {
    await database.session.put({
      key: 'storage',
      supported: false,
      persisted: false,
      requestedAt: Date.now(),
    });
    return;
  }
  let persisted = false;
  try {
    persisted = await manager.persist();
  } catch {
    persisted = false;
  }
  await database.session.put({
    key: 'storage',
    supported: true,
    persisted,
    requestedAt: Date.now(),
  });
}
